import v2AxiosInstance from "../../../../../interceptor/v2AxiosInstance";
import { ACTIVE_COUNT, ACTIVE_STUDENTS, LOGINS_COUNT, NO_OF_LOGINS, NOT_LOGGED_IN, NOT_LOGGED_IN_COUNT, SIGNUPS, SIGNUPS_COUNT, STUDENT_ACTIVITIES, PDF_VIEWED, VIDEO_VIEWED, QUICK_QUIZ_COUNT, EXERCISE_COUNT, CLASS_LOGINS, BRANCH_LOGINS } from "../../../../../routes/routeConstants/V2/apiRoutes";

export default class V2DashboardService {
  static getLoginsCount(
    params: any,
    onSuccess: (data: any) => void,
    onError: Function,
    onFinal: () => void
  ) {
    return v2AxiosInstance
      .get(LOGINS_COUNT, { params })
      .then((response) => {
        onSuccess(response.data["count"]);
      })
      .catch((e) => {
        onError(e);
      })
      .finally(onFinal);
  }

  static getActiveCount(
    params: any,
    onSuccess: (data: any) => void,
    onError: Function,
    onFinal: () => void
  ) {
    return v2AxiosInstance
      .get(ACTIVE_COUNT, { params })
      .then((response) => {
        onSuccess(response.data["count"]);
      })
      .catch((e) => {
        onError(e);
      })
      .finally(onFinal);
  }

  static getNotLoggedInCount(
    params: any,
    onSuccess: (data: any) => void,
    onError: Function,
    onFinal: () => void
  ) {
    return v2AxiosInstance
      .get(NOT_LOGGED_IN_COUNT, { params })
      .then((response) => {
        onSuccess(response.data["count"]);
      })
      .catch((e) => {
        onError(e);
      })
      .finally(onFinal);
  }

  static getSignupsCount(
    params: any,
    onSuccess: (data: any) => void,
    onError: Function,
    onFinal: () => void
  ) {
    return v2AxiosInstance
      .get(SIGNUPS_COUNT, { params })
      .then((response) => {
        onSuccess(response.data["count"]);
      })
      .catch((e) => {
        onError(e);
      })
      .finally(onFinal);
  }
  static getNoOfLoggedInStudents(
    params: any,
    onSuccess: (data: any) => void,
    onError: Function,
    onFinal: () => void
  ) {
    return v2AxiosInstance
      .get(NO_OF_LOGINS, { params })
      .then((response) => {
        onSuccess(response.data["students"]);
      })
      .catch((e) => {
        onError(e);
      })
      .finally(onFinal);
  }
  static getNotLoggedInStudents(
    params: any,
    onSuccess: (data: any) => void,
    onError: Function,
    onFinal: () => void
  ) {
    return v2AxiosInstance
      .get(NOT_LOGGED_IN, { params })
      .then((response) => {
        onSuccess(response.data["students"]);
      })
      .catch((e) => {
        onError(e);
      })
      .finally(onFinal);
  }

  static getSignUps(
    params: any,
    onSuccess: (data: any) => void,
    onError: Function,
    onFinal: () => void
  ) {
    return v2AxiosInstance
      .get(SIGNUPS, { params })
      .then((response) => {
        onSuccess(response.data["students"]);
      })
      .catch((e) => {
        onError(e);
      })
      .finally(onFinal);
  }

  static getActiveStudents(
    params: any,
    onSuccess: (data: any) => void,
    onError: Function,
    onFinal: () => void
  ) {
    return v2AxiosInstance
      .get(ACTIVE_STUDENTS, { params })
      .then((response) => {
        onSuccess(response.data["students"]);
      })
      .catch((e) => {
        onError(e);
      })
      .finally(onFinal);
  }
  static fetchCompletedActivities(
    params: any,
    onSuccess: (data: any) => void,
    onError: Function,
    onFinal: () => void
  ) {
    return v2AxiosInstance
      .get(`${STUDENT_ACTIVITIES}/${params.id}`, { params })
      .then((response) => {
        onSuccess(response.data);
      })
      .catch((e) => {
        onError(e);
      })
      .finally(onFinal);
  }

  static getPDFViewed(
    params: any,
    onSuccess: (data: any) => void,
    onError: Function,
    onFinal: () => void
  ) {
    return v2AxiosInstance
      .get(PDF_VIEWED, { params })
      .then((response) => {
        onSuccess(response.data["count"]);
      })
      .catch((e) => {
        onError(e);
      })
      .finally(onFinal);
  }

  static getVideoViewed(
    params: any,
    onSuccess: (data: any) => void,
    onError: Function,
    onFinal: () => void
  ) {
    return v2AxiosInstance
      .get(VIDEO_VIEWED, { params })
      .then((response) => {

        onSuccess(response.data["count"]);
      })
      .catch((e) => {
        onError(e);
      })
      .finally(onFinal);
  }

  static getQuickQuicCount(
    params: any,
    onSuccess: (data: any) => void,
    onError: Function,
    onFinal: () => void
  ) {
    return v2AxiosInstance
      .get(QUICK_QUIZ_COUNT, { params })
      .then((response) => {

        onSuccess(response.data["count"]);
      })
      .catch((e) => {
        onError(e);
      })
      .finally(onFinal);
  }

  static getExerciseCount(
    params: any,
    onSuccess: (data: any) => void,
    onError: Function,
    onFinal: () => void
  ) {
    return v2AxiosInstance
      .get(EXERCISE_COUNT, { params })
      .then((response) => {
        onSuccess(response.data["count"]);
      })
      .catch((e) => {
        onError(e);
      })
      .finally(onFinal);
  }
  static getClassLogins(
    params: any,
    onSuccess: (data: any) => void,
    onError: Function,
    onFinal: () => void
  ) {
    return v2AxiosInstance
      .get(CLASS_LOGINS, { params })
      .then((response) => {
        onSuccess(response.data);
      })
      .catch((e) => {
        onError(e);
      })
      .finally(onFinal);
  }

  static getBranchLogins(
    params: any,
    onSuccess: (data: any) => void,
    onError: Function,
    onFinal: () => void
  ) {
    return v2AxiosInstance
      .get(BRANCH_LOGINS, { params })
      .then((response) => {
        onSuccess(response.data);
      })
      .catch((e) => {
        onError(e);
      })
      .finally(onFinal);
  }
}

